import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {DownloadDelivery} from "./download-delivery";

export const downloadDeliveryModules = ({}) => [
    {
        load: ({downloadDelivery2}, next) => next({
            ui: downloadDelivery2?.ui && (
                ({className}) => DownloadDelivery({
                    ...downloadDelivery2.ui,
                    className,
                })
            ),
        }),
        expo: [ui("downloadDelivery")],
        requires: ["downloadDelivery2"],
    },
];
